// import cookie from 'react-cookies'
// export default function authHeader() {
//     // const token = localStorage.getItem('token');
//     const tokens = cookie.load('token')
//     console.log(tokens)
//       return {  
//          Authorization: tokens,
//         businessName: 'topupbox',
//     };
   
//   }

import cookie from 'react-cookies'
import { getBranding } from "../utils/getBranding"; // adjust path

export default function authHeader() {
  const token = localStorage.getItem('token');
  const tokens = cookie.load('token');
  const branding = getBranding();

  return {
    Authorization: tokens,
    businessName: branding?.businessName || "", 
  };
}
